import ErrorGoHome from '@anm/components/errors/ErrorGoHome';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { userSelectors } from '../../../store/modules/user';
import ManageTeam from '../ManageTeam';

export type ManageTeamSectionProps = {};

const Wrapper = styled.div`
  max-width: 840px;
`;

const ManageTeamSection: FC<ManageTeamSectionProps> = () => {
  const teamId = useSelector(userSelectors.selectTeamId);

  return <Wrapper>{teamId ? <ManageTeam /> : <ErrorGoHome />}</Wrapper>;
};

export default ManageTeamSection;
